import { __decorate } from "tslib";
import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import { uiMapper } from "@/services/store/modules/ui/store";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
});
const DataMappers = Vue.extend({
    computed: {},
    methods: {},
});
let ItemAdv = class ItemAdv extends Mixins(UiMappers, DataMappers) {
};
__decorate([
    Prop()
], ItemAdv.prototype, "item", void 0);
__decorate([
    Prop()
], ItemAdv.prototype, "displayBg", void 0);
__decorate([
    Prop()
], ItemAdv.prototype, "isBold", void 0);
ItemAdv = __decorate([
    Component({
        components: {},
    })
], ItemAdv);
export default ItemAdv;
